import CONSTANTES from "../constantes";

const stateconfig = {
   permisos:[],
}

export const reducerConfig = (state =stateconfig, action) => {
  switch (action.type) {
    case CONSTANTES.PUT_CONFIG:
      return { ...state, 
        permisos: action.permisos,
      }
    default:
      return state;
  }
}

